import { NOTIFICATION_TYPE } from '@utils/constants/notification.constant';
import { NavigateFunction } from 'react-router-dom';
import { subjectRouteFromId } from '@utils/helpers/SubjectParser';
import { QuizQuestionType } from '@models/interfaces/online_lesson.interface';

export interface IPostClassEvent {
  subjectId: number;
  onlineLessonId: number;
  quizType: string;
  className?: string;
}

export interface IClassToSmartEvent {
  subjectId: number;
  onlineLessonId: number;
}

// return false if the notification have no action
export function NotificationAction(
  type: number,
  navigate: NavigateFunction,
  worksheetId: number = 0,
  subjectId: number = 0,
  onlineLessonId: number = 0,
  className?: string,
  url?: string,
) {
  const subjectRoute = subjectRouteFromId(Number(subjectId)) || 'mathematics';

  switch (type) {
    case NOTIFICATION_TYPE.NOTIF_WS_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIFICATION_DIAGNOSTIC_ASSESSMENT_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_WORKSHEET_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIFICATION_WS_HOMEWORK_ASSIGNED:
    case NOTIFICATION_TYPE.NOTIF_ASSIGN_WS:
      return () =>
        navigate(
          `/${subjectRoute}/worksheets/worksheet_question/${worksheetId}`,
        );
    case NOTIFICATION_TYPE.NOTIFICATION_REVISION_GROUP:
      return () => navigate(`/${subjectRoute}/worksheets/create`);
    case NOTIFICATION_TYPE.NOTIF_CONCEPT_IMPROVEMENT:
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_INCREASED:
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_DECREASED:
      return () => navigate(`/${subjectRoute}/progress`);
    case NOTIFICATION_TYPE.NOTIFICATION_NEW_LEADERBOARD_ENDING:
    case NOTIFICATION_TYPE.NOTIFICATION_NEW_LEADERBOARD_ENDED:
      return () => navigate('/leaderboard');
    case NOTIFICATION_TYPE.NOTIF_BUBBLES_ADJUSTMENT_FROM_ADMIN:
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_PARENT_TRANSFER:
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_SALVAGED:
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_NORMAL:
    case NOTIFICATION_TYPE.NOTIFICATION_STREAK_V2_RESET:
    case NOTIFICATION_TYPE.NOTIFICATION_STUDY_PLAN:
    case NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_DECAYED:
      return () => navigate(`/${subjectRoute}/worksheets`);
    case NOTIFICATION_TYPE.NOTIFICATION_ONLINE_LESSON_START:
      return () => navigate(`/${subjectRoute}/classes`);
    case NOTIFICATION_TYPE.NOTIFICATION_ONLINE_LESSON_UPCOMING:
      return () => navigate(`/${subjectRoute}/classes`);
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_PRECLASS:
      return () => {
        const postClassEvent = new CustomEvent<IPostClassEvent>(
          'postClassEvent',
          {
            detail: {
              subjectId: subjectId,
              onlineLessonId: onlineLessonId,
              quizType: QuizQuestionType.PRE_QUIZ,
              className,
            },
          },
        );
        window.dispatchEvent(postClassEvent);
      };
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_POSTCLASS:
      return () => {
        const postClassEvent = new CustomEvent<IPostClassEvent>(
          'postClassEvent',
          {
            detail: {
              subjectId: subjectId,
              onlineLessonId: onlineLessonId,
              quizType: QuizQuestionType.POST_QUIZ,
              className,
            },
          },
        );
        window.dispatchEvent(postClassEvent);
      };
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_TO_GENIESMART:
      return () => {
        const classToSmartEvent = new CustomEvent<IClassToSmartEvent>(
          'classToSmartEvent',
          {
            detail: {
              subjectId: subjectId,
              onlineLessonId: onlineLessonId,
            },
          },
        );
        window.dispatchEvent(classToSmartEvent);
      };
    case NOTIFICATION_TYPE.NOTIF_WS_MARKED:
      return () =>
        navigate(`/${subjectRoute}/worksheets/completed/${worksheetId}`);
    case NOTIFICATION_TYPE.NOTIFICATION_GENIECLASS_PERFORMANCE:
      return () =>
        navigate(`/${subjectRoute}/classes/report/${onlineLessonId}`);
    case NOTIFICATION_TYPE.NOTIF_BUBBLE_EXPIRED:
      return () => {
        if (url !== undefined && url !== '') window.open(url, '_blank');
      };
    case NOTIFICATION_TYPE.NOTIFICATION_ONLINE_LESSON_RECORDED:
      return () =>
        navigate({
          pathname: `/${subjectRoute}/classes/recorded/${onlineLessonId}`,
        });
    case NOTIFICATION_TYPE.NOTIF_BADGE_EARNED:
      return () => navigate('/badges');
    case NOTIFICATION_TYPE.NOTIF_EXAM_RESULT_REJECTED:
    case NOTIFICATION_TYPE.NOTIF_EXAM_RESULT_REWARD:
      return () => navigate('/exam-result');
    default:
      return false;
  }
}
